const HeroBanner = () => {
  return (
    <>
      {" "}
      <div className="bg-primary-grey rounded-t-lg p-8 md:p-24 text-center text-white text-xl md:text-5xl bg-bgProfileBanner bg-cover bg-no-repeat bg-cover backdrop-opacity-0 backdrop-invert  bg-black/70 bg-blend-color-burn font-bold z-0"></div>
    </>
  );
};

export default HeroBanner;
